import React, {useEffect, useState} from 'react';
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack';
import {SizeMe} from 'react-sizeme'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import {
    CircularProgress,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    useMediaQuery
} from "@material-ui/core";
import {InvoiceRequest, InvoiceResponse, InvoiceTempPdf} from "../../../../Api/data/invoice/types";
import {generateInvoice, updateInvoice} from "../../../../Api/data/invoice/client";
import {useTheme} from "@material-ui/core/styles";
import useStyles from "./styles";
import {Close} from "@material-ui/icons";

interface IInvoicePreviewProps {
    invoice: InvoiceResponse;
    onClose?: (filesUpdated?: boolean, filesToSend?: number[]) => void;
}

const InvoicePreview: React.FC<IInvoicePreviewProps> = ({ invoice, onClose}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useStyles();

    const [pdfString, setPdfString] = useState<string>();
    const [ tempPdf, setTempPdf ] = useState<InvoiceTempPdf>();
    const [ numPages, setNumPages ] = useState<number>();
    const [ loading, setLoading ] = useState<boolean>(true);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const handleClose = () => {
        if(onClose) {
            onClose();
        }
    }

    const confirm = (send?: boolean) => {
        updateInvoice(invoice.invoiceID, {
            ...invoice,
            files: tempPdf?.id
        } as InvoiceRequest).then((response: InvoiceResponse) => {
            if(onClose) {
                debugger
                const addedFiles = response.invoiceFiles?.filter(of => tempPdf?.id.includes(of.fileID));
                onClose(true, send ? addedFiles?.map(f => f.invoiceFileID) : undefined);
            }
        })
    }

    const handleConfirm = () => {
        confirm();
    }

    const handleConfirmAndSend = () => {
        confirm(true);
    }

    useEffect(() => {
        if (invoice.invoiceID) {
            setLoading(true);
            generateInvoice(invoice.invoiceID).then(r => {
                setTempPdf(r);
            });
        }
        else {
            console.error("No invoice loaded")
        }
    }, [invoice]);


    useEffect(() => {
        if (tempPdf) {
            let reader = new FileReader();
            reader.readAsDataURL(tempPdf.data);
            reader.onloadend = () => {
                const base64String = reader.result as string;
                setLoading(false);
                setPdfString(base64String.substr(base64String.indexOf(',') + 1));
            };
        }
        else {
            setLoading(false);
            setPdfString(undefined);
        }

    }, [tempPdf]);


    return (
        <div>
            <Dialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={true}
                fullScreen={fullScreen}
                maxWidth={false}
            >
                <DialogTitle id="customized-dialog-title">
                    Náhled faktury
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers className={classes.offerPreviewDialogContent}>
                    { loading ? (
                        <CircularProgress />
                    ) : (
                        <SizeMe>
                            {({size}) => (
                                <Document
                                    file={`data:application/pdf;base64,${pdfString}`}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                >
                                    <Page pageNumber={1} width={size.width ? size.width : 1} />
                                </Document>
                            )}
                        </SizeMe>
                    )}

                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleConfirmAndSend} color="primary" variant={"contained"}>
                        Přiřadit a odeslat
                    </Button>
                    <Button onClick={handleConfirm} color="primary" variant={"contained"}>
                        Přiřadit
                    </Button>
                    <Button onClick={handleClose} color="secondary" variant={"contained"}>
                        Zahodit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default InvoicePreview;